import styled from "styled-components";

export const SearchWrapper = styled.div`
  position: relative;
`;

export const SearchInput = styled.input`
  background: ${(props) => (props.whiteText ? "transparent" : (props) => props.theme.bgColor)};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 25px;
  min-width: 250px;
  height: 40px;
  width: 300px;
  padding: 5px 50px 5px 10px;
  color: ${(props) => (props.whiteText ? "#fff" : (props) => props.theme.textColor)};
  @media (max-width: 1199px) {
    width: 250px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const SearchLogo = styled.button`
  border: none;
  cursor: pointer;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  @media (max-width: 768px) {
    display: none;
  }
`;
